import React, { FC } from "react";

interface SmartBuyerCalculatorResults {
    legal: number;
    survey: number;
}
export const SmartBuyerCalculatorResults: FC<SmartBuyerCalculatorResults> = ({ legal, survey }) => (
  <div className="smart-buyer-calculator-results">
    <div className="smart-buyer-calculator-total">
      <p>Estimated Total</p>
      <span>
        £
        {legal + survey}
      </span>
    </div>
    <div className="smart-buyer-calculator-includes">
      <p>This includes:</p>
      <div className="smart-buyer-calculator-tile">
        <span>All your conveyancing and legal work</span>
        <p>
          worth
          &nbsp;
          £
          {legal}
        </p>
      </div>
      <div className="smart-buyer-calculator-tile">
        <span>Property survey</span>
        <p>
          worth
          &nbsp;
          £
          {survey}
        </p>
      </div>
    </div>
  </div>
);
